const routerList = [

	{
		path:"/404",
		component:"System/404",
		name:'404',
	},
	{
		path:"/notice/:msgCode",
		component:"System/Notice",
		name:'notice',
	},

	{
		path:"/login",
		component:"System/Login",
		name:'login',
	},
	{
		path:"/wechatBind/:wechatId",
		component:"System/WechatBind",
		name:'wechatBind',
	},

	{
		path:"/redirectByUrl/:to/:token",
		component:"System/RedirectByUrl",
		name:'redirectByUrl',
	},

	{
		path:"/index/:menuActive?",
		component:"System/Index",
		name:'index',
	},

	{
		path:"/record/:id",
		component:"Function/Record",
		name:'record',
	},

	{
		path:"/review",
		component:"Function/Review",
		name:'review',
	},
	{
		path:"/shareFoorprints/:id",
		component:"Function/ShareFoorprints",
		name:'shareFoorprints',
	},
	{
		path:"/achievement",
		component:"Function/Achievement",
		name:'achievement',
	},
	{
		path:"/shareAchievement/:id",
		component:"Function/ShareAchievement",
		name:'shareAchievement',
	},

	{
		path:"/settings/:menuActive?",
		component:"System/Settings",
		name:'settings',
	},
	{
		path:'/resetPassword/:id',
		component:"System/ResetPassword",
		name:'resetPassword',
	},
	{
		path:"/changeMail/:id",
		component:"System/ChangeMail",
		name:'changeMail',
	},
	{
		path:'/forget',
		component:"System/Forget",
		name:'forget',
	},
	{
		path:'/signup',
		component:"System/Signup",
		name:'signup',
	},

	{
		path:"/about",
		component:"Function/About",
		name:'about',
	},
	
];

export default  (()=>{
	let router = [];
	for(let v of routerList){
		router.push({
			path:v.path,
			name:v.name,
			component:resolve=>require([`@/views/${v.component}`], resolve),
			meta:v,
		})
	}

	return router
});



// WEBPACK FOOTER //
// ./src/router/routerList.js